import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CircularProgress from '@mui/material/CircularProgress';
import * as Text from 'theme/components/Text.style';
import ThreeDots from './ThreeDots';

export interface LoaderProps {
  inline?: boolean;
  type?: string;
}

const Loader = ({ inline, type }: LoaderProps): JSX.Element => {
  const { t } = useTranslation('pageEcoach');

  const [showApology, setShowApology] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowApology(true);
    }, 30000); // 30 seconds

    return () => clearTimeout(timer);
  }, []);

  const apologyText = t(
    'Loader.It looks like there may have been an error. Please try refreshing the page or check back in a moment.'
  );

  const actionPlanText = showApology
    ? apologyText
    : t('Loader.Finding the best answer for your situation…');
  const convoPrepText = showApology
    ? apologyText
    : t(
        'Loader.Analyzing billions of sources to generate your personalized conversation plan.'
      );

  if (inline) return <CircularProgress size={25} />;
  if (type === 'typing') return <ThreeDots />;

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
      <div>
        <CircularProgress size={25} />
      </div>
      <Text.P2>
        {type === 'action plan' ? actionPlanText : convoPrepText}
      </Text.P2>
    </div>
  );
};

export default Loader;
